"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _reactRedux = require("react-redux");

var _useGetIntegrationsByUserId = require("../../../Shared/Users/hooks/useGetIntegrationsByUserId");

var _giftingFlow = require("../../store/giftingFlow.selectors");

var _integrations = require("../../../Shared/Users/store/integrations/integrations.types");

var _hooks = require("../../hooks");

var _NotConnectedContent = _interopRequireWildcard(require("./NotConnectedContent"));

var IntegrationConnectionWarning = function IntegrationConnectionWarning(_ref) {
  var teamId = _ref.teamId,
      sendAsId = _ref.sendAsId,
      wrapperProps = (0, _objectWithoutProperties2.default)(_ref, ["teamId", "sendAsId"]);
  var isIntegrationDataFulfilled = (0, _reactRedux.useSelector)(_giftingFlow.getIsIntegrationDataFulfilled);

  var _useGetIntegrationsBy = (0, _useGetIntegrationsByUserId.useGetIntegrationsByUserId)(sendAsId),
      integrations = _useGetIntegrationsBy.integrations;

  var _useGetIntegrationWar = (0, _hooks.useGetIntegrationWarningSettings)({
    teamId,
    sendAsId
  }),
      hasWarning = _useGetIntegrationWar.hasWarning,
      isIntegrationBroken = _useGetIntegrationWar.isIntegrationBroken;

  var isDefault = (integrations === null || integrations === void 0 ? void 0 : integrations.email.provider) === _integrations.IntegrationProvider.Default;
  var isDkim = (integrations === null || integrations === void 0 ? void 0 : integrations.email.provider) === _integrations.IntegrationProvider.Dkim;
  var isNotConnected = isIntegrationDataFulfilled && !isIntegrationBroken && isDefault;
  return /*#__PURE__*/_react.default.createElement(_material.Box, wrapperProps, /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: hasWarning,
    unmountOnExit: true
  }, isNotConnected && /*#__PURE__*/_react.default.createElement(_NotConnectedContent.default, {
    teamId: teamId,
    sendAsId: sendAsId,
    isDkimProvider: isDkim,
    variant: _NotConnectedContent.NotConnectedContentVariant.Warning
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(IntegrationConnectionWarning);

exports.default = _default;